import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: components/First/index.tsx の useState(activeTab) を再現。
// about/guide タブを切り替え、ボタンのクラスと tab2 画像を更新する。
class SiteFirstFirstController extends Controller {
  static targets = ["aboutBtn", "guideBtn", "aboutPane", "guidePane", "tab2img"];

  declare readonly aboutBtnTarget: HTMLButtonElement;
  declare readonly guideBtnTarget: HTMLButtonElement;
  declare readonly aboutPaneTarget: HTMLElement;
  declare readonly guidePaneTarget: HTMLElement;
  declare readonly tab2imgTarget: HTMLImageElement;

  switch(event: Event): void {
    const tab = (event.currentTarget as HTMLElement).dataset.tab;
    const about = tab === "about";
    this.aboutBtnTarget.className = about ? "First_tabActive" : "First_tab";
    this.guideBtnTarget.className = about ? "First_tab" : "First_tabActive";
    this.aboutPaneTarget.hidden = !about;
    this.guidePaneTarget.hidden = about;
    this.tab2imgTarget.src = about ? "/first/tab2.png" : "/first/tab2_active.png";
  }
}

application.register("site--first--first", SiteFirstFirstController);
